import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { ExtraLongCustomButton } from '../custom-material/button/Button'
import CustomDialog from '../custom-material/dialog/Dialog'

const styles = theme => ({
  dialogPaper: {
    width: 400,
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  confirmMessageContainer: {
    padding: 16,
    textAlign: 'center'
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 16
  },
  yesButton: {
    marginLeft: 5,
    fontSize: 14,
    fontWeight: 600
  },
  cancelButton: {
    fontSize: 14,
    fontWeight: 600
  }
})

const turnOnPrompt = <div>
  <p>You have created an email preference!</p>
  <p>Select "Update Settings" if you would like to update your settings to only receive email publications for your favorited drugs and saved preferences.</p>
  <p>
    If you select "Don't Update Settings", you will continue to receive All Real-Time Insight Publications.
    This can be changed at any time using the Real-Time Insight Publications Settings toggles.
  </p>
</div>

const turnOffPrompt = <div>
  <p>You have removed all email preferences.</p>
  <p>Select "Update Settings" if would you like to update your settings to receive All Real-Time Insight Publications.</p>
  <p>
    If you select "Don't Update Settings", you will only receive Real-Time Insight Publications for your favorited drugs until you create new email preferences.
    This can be changed at any time using the Real-Time Insight Publications Settings toggles.
  </p>
</div>

const PromptFilterPreferredDialog = ({classes, dialogOpen, handleCloseDialog, confirm, turnOn}) => (
  <CustomDialog classes={{paper: classes.dialogPaper}} open={dialogOpen} onClose={handleCloseDialog}>
    <div className={classes.contentContainer}>
      <div className={classes.confirmMessageContainer}>
        {turnOn ? turnOnPrompt : turnOffPrompt }
      </div>
      <div className={classes.actionContainer}>
        <ExtraLongCustomButton className={classes.cancelButton} onClick={handleCloseDialog} variant='contained' size='small' color='default' >Don't Update Settings</ExtraLongCustomButton>
        <ExtraLongCustomButton className={classes.yesButton} onClick={() => { confirm(); return handleCloseDialog() }} variant='contained' size='small' color='secondary' >Update Settings</ExtraLongCustomButton>
      </div>
    </div>
  </CustomDialog>
)

PromptFilterPreferredDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  turnOn: PropTypes.bool.isRequired
}

export default withStyles(styles)(PromptFilterPreferredDialog)
